import React, { useState } from "react";
import { toggle } from "../../../util/common";
import { WalletItemBankAccount } from "../../../store/common";
import { DialogComponent } from "../../common/DialogComponent";
import ConfirmDeleteWalletDialog from "../../Dialogs/lostWallet/ConfirmDeleteWalletDialog";
import BankAccountDialog from "../../Dialogs/lostWallet/BankAccountDialog";
import i18nService from "../../../util/Internationalization/i18n/i18n";
import { useTranslation } from "react-i18next";

const BankAccount: React.FunctionComponent<{ requestDataCallback(): void; walletItemBankAccounts: WalletItemBankAccount[] }> = (props) => {
    const { t: tLang, i18n: i18nLang } = useTranslation();
    const [deleteWalletDialogIsVisible, setDeleteWalletDialogIsVisible] = useState(false);
    const [bankAccountDialogIsVisible, setBankAccountDialogIsVisible] = useState(false);
    const [selectedItem, setSelectedItem] = useState({});
    const [bankAccountNumber,setBankAccountNumber]:any= useState([]);
    
    const accountType = {
        CONSUMER_CHECKING: tLang("identityVault.secureStorage.lostWallterWidget.addBankAccountPopup.label.typeOfAccountList.checkingAccount"),
        CONSUMER_SAVINGS: tLang("identityVault.secureStorage.lostWallterWidget.addBankAccountPopup.label.typeOfAccountList.savingsAccount"),
        CONSUMER_JOINT_SAVINGS: tLang("identityVault.secureStorage.lostWallterWidget.addBankAccountPopup.label.typeOfAccountList.jointSavingsAccount"),
        COMMERCIAL_CHECKING: tLang("identityVault.secureStorage.lostWallterWidget.addBankAccountPopup.label.typeOfAccountList.commercialCheckingAccount"),
        LINE_CREDIT: tLang("identityVault.secureStorage.lostWallterWidget.addBankAccountPopup.label.typeOfAccountList.lineOfCredit"),
        MONEY_MARKET: tLang("identityVault.secureStorage.lostWallterWidget.addBankAccountPopup.label.typeOfAccountList.moneyMarket"),
        OTHER: tLang("identityVault.secureStorage.lostWallterWidget.addBankAccountPopup.label.typeOfAccountList.other"),
    };

    const showDeleteWalletDialog = (selectedItem: WalletItemBankAccount): any => {
        setSelectedItem(selectedItem);
        setDeleteWalletDialogIsVisible(true);
    };

    const closeDeleteWalletDialog = (): any => {
        setDeleteWalletDialogIsVisible(false);
    };

    const showBankAccountDialog = (selectedItem: WalletItemBankAccount): any => {
        setSelectedItem(selectedItem);
        setBankAccountDialogIsVisible(true);
    };

    const closeBankAccountDialog = (): any => {
        setBankAccountDialogIsVisible(false);
    };

     const toggleAccNumVisibility =(bankAccount:any) =>{
        if (bankAccountNumber.length > 0) {
            const index = bankAccountNumber.findIndex((element: any) => element.accountNumber ===   bankAccount.accountNumber);
         if (index >= 0) {
            bankAccountNumber.splice(index, 1);
            setBankAccountNumber([...bankAccountNumber]);
        } 
         else {
            setBankAccountNumber([...bankAccountNumber, bankAccount]);
         }
          } else {
             setBankAccountNumber([...bankAccountNumber , bankAccount]);
         }
     }
    function getAccountType(key: any): string {
        let ruturnVal = "";
        switch (key) {
            case "CONSUMER_CHECKING":
                ruturnVal = accountType.CONSUMER_CHECKING;
                break;
            case "CONSUMER_SAVINGS":
                ruturnVal = accountType.CONSUMER_SAVINGS;
                break;
            case "CONSUMER_JOINT_SAVINGS":
                ruturnVal = accountType.CONSUMER_JOINT_SAVINGS;
                break;
            case "COMMERCIAL_CHECKING":
                ruturnVal = accountType.COMMERCIAL_CHECKING;
                break;
            case "LINE_CREDIT":
                ruturnVal = accountType.LINE_CREDIT;
                break;
            case "MONEY_MARKET":
                ruturnVal = accountType.MONEY_MARKET;
                break;
            case "OTHER":
                ruturnVal = accountType.OTHER;
                break;

            default:
                ruturnVal = "";
                break;
        }
        return ruturnVal;
    }

    return (
        <React.Fragment>
            {props.walletItemBankAccounts &&
                props.walletItemBankAccounts.map((bankAccount: WalletItemBankAccount, index) => (
                    <div className="data-row" key={"bank-account-" + index}>
                        <div className="link-item">
                            <button
                                type="button"
                                aria-expanded="false"
                                className="link-button"
                                id={"btn-bank-account-" + index}
                                onClick={() => toggle(`bank-account-${index}-details`, `btn-bank-account-${index}`)}
                            >
                                <span className="row link-item">
                                    <span className="col-xs col-no-gutter link-text">
                                        <span className="link-title">
                                            <span className="btn-toggle-status sr-only">Show</span>
                                            {bankAccount.institutionName}
                                        </span>
                                        <span className="link-helper">
                                            <span className="sr-only">Item Type: </span>
                                            {tLang("identityVault.secureStorage.lostWallterWidget.addBankAccountPopup.title2")}
                                        </span>
                                    </span>
                                </span>
                            </button>

                            <div className="wallet-details" id={"bank-account-" + index + "-details"} style={{ display: "none" }}>
                                <div
                                    role="grid"
                                    className="data-grid row-height-xs"
                                    id={"bank-account-" + index + "-title"}
                                    aria-labelledby={"bank-account-" + index + "-title"}
                                >
                                    <div role="row" className="data-row condensed row">
                                        <div className="col-xs-12 col-sm-4 col-no-gutter">
                                            <div role="gridcell" className="data-label" id={"bank-account-" + index + "-type-of-account"}>
                                                {tLang("identityVault.secureStorage.lostWallterWidget.addBankAccountPopup.label.type")}
                                            </div>
                                        </div>
                                        <div className="col-xs-11 col-sm-7 col-no-gutter">
                                            <div role="gridcell" className="data-value" aria-labelledby={"bank-account-" + index + "-type-of-account"}>
                                                {getAccountType(bankAccount.accountType)}
                                            </div>
                                        </div>
                                    </div>
                                    <div role="row" className="data-row condensed row">
                                        <div className="col-xs-12 col-sm-4 col-no-gutter">
                                            <div role="gridcell" className="data-label" id={"bank-account-" + index + "-financial-institution-name"}>
                                                {tLang("identityVault.secureStorage.lostWallterWidget.addBankAccountPopup.label.institutionName")}
                                            </div>
                                        </div>
                                        <div className="col-xs-11 col-sm-7 col-no-gutter">
                                            <div role="gridcell" className="data-value" aria-labelledby={"bank-account-" + index + "-financial-institution-name"}>
                                                {bankAccount.institutionName}
                                            </div>
                                        </div>
                                    </div>
                                    <div role="row" className="data-row condensed row">
                                        <div className="col-xs-12 col-sm-4 col-no-gutter">
                                            <div role="gridcell" className="data-label" id={"bank-account-" + index + "-account-number"}>
                                                {tLang("identityVault.secureStorage.lostWallterWidget.addBankAccountPopup.label.acNumber")}
                                            </div>
                                        </div>
                                        <div className="col-xs-11 col-sm-7 col-no-gutter">
                                            <div role="gridcell" className="data-value" aria-labelledby={"bank-account-" + index + "-account-number"}>
                                              {bankAccount &&
                                                     bankAccount.accountNumber && (bankAccountNumber.findIndex((element: any) => element.accountNumber === bankAccount.accountNumber)) ?
                                                      `${"X".repeat(
                                                        bankAccount.accountNumber.substring(0, bankAccount.accountNumber.length - 4).length
                                                      )}${bankAccount.accountNumber.substring(bankAccount.accountNumber.length - 4)}` : bankAccount.accountNumber} 

                                            <button
                                                type="button"
                                                className="btn-default btn-icon-only btn-no-padding"
                                                onClick={() => {
                                                    toggleAccNumVisibility(bankAccount);
                                                }}
                                                    title={tLang("identityVault.secureStorage.lostWallterWidget.accountTooltipMsg")}
                                                style={{marginLeft: '1.25rem'}}
                                            >
                                                <span className="btn-icon">
                                                    <em
                                                        className={`las ${
                                                            bankAccountNumber.findIndex((element: any) => element.accountNumber === bankAccount.accountNumber) < 0 ? "la-eye" : "la-eye-slash"
                                                        }`}
                                                    ></em>
                                                </span>
                                                <span className="btn-text">Show / Hide AccountNumber Text</span>
                                            </button>
                                            </div>
                                        </div>
                                    </div>
                                    <div role="row" className="data-row condensed row">
                                        <div className="col-xs-12 col-sm-4 col-no-gutter">
                                            <div role="gridcell" className="data-label" id={"bank-account-" + index + "-address"}>
                                                {tLang("identityVault.secureStorage.lostWallterWidget.addBankAccountPopup.label.address")}
                                            </div>
                                        </div>
                                        <div className="col-xs-11 col-sm-7 col-no-gutter">
                                            <div role="gridcell" className="data-value" aria-labelledby={"bank-account-" + index + "-address"}>
                                                {bankAccount.street}
                                            </div>
                                        </div>
                                    </div>
                                    <div role="row" className="data-row condensed row">
                                        <div className="col-xs-12 col-sm-4 col-no-gutter">
                                            <div role="gridcell" className="data-label" id={"bank-account-" + index + "-city"}>
                                                {tLang("identityVault.secureStorage.lostWallterWidget.addBankAccountPopup.label.city")}
                                            </div>
                                        </div>
                                        <div className="col-xs-11 col-sm-7 col-no-gutter">
                                            <div role="gridcell" className="data-value" aria-labelledby={"bank-account-" + index + "-city"}>
                                                {bankAccount.city}
                                            </div>
                                        </div>
                                    </div>
                                    <div role="row" className="data-row condensed row">
                                        <div className="col-xs-12 col-sm-4 col-no-gutter">
                                            <div role="gridcell" className="data-label" id={"bank-account-" + index + "-state"}>
                                                {tLang("identityVault.secureStorage.lostWallterWidget.addBankAccountPopup.label.state", {
                                                    stateLabel: i18nService.get("State.Label"),
                                                })}
                                            </div>
                                        </div>
                                        <div className="col-xs-11 col-sm-7 col-no-gutter">
                                            <div role="gridcell" className="data-value" aria-labelledby={"bank-account-" + index + "-state"}>
                                                {bankAccount.state}
                                            </div>
                                        </div>
                                    </div>
                                    <div role="row" className="data-row condensed row">
                                        <div className="col-xs-12 col-sm-4 col-no-gutter">
                                            <div role="gridcell" className="data-label" id={"bank-account-" + index + "-zip"}>
                                                {tLang("identityVault.secureStorage.lostWallterWidget.addBankAccountPopup.label.zipCode", {
                                                    zipCodeLabel: i18nService.get("ZipCode.Label"),
                                                })}
                                            </div>
                                        </div>
                                        <div className="col-xs-11 col-sm-7 col-no-gutter">
                                            <div role="gridcell" className="data-value" aria-labelledby={"bank-account-" + index + "-zip"}>
                                                {bankAccount.zip}
                                            </div>
                                        </div>
                                    </div>
                                    <div role="row" className="data-row condensed row">
                                        <div className="col-xs-12 col-sm-4 col-no-gutter">
                                            <div role="gridcell" className="data-label" id={"bank-account-" + index + "-phone"}>
                                                {tLang("identityVault.secureStorage.lostWallterWidget.addBankAccountPopup.label.phoneNumber")}
                                            </div>
                                        </div>
                                        <div className="col-xs-11 col-sm-7 col-no-gutter">
                                            <div role="gridcell" className="data-value" aria-labelledby={"bank-account-" + index + "-phone"}>
                                              {bankAccount.phoneNumber }
                                            </div>
                                        </div>
                                    </div>
                                    <div role="row" className="data-row condensed row">
                                        <div className="col-xs-12 col-sm-4 col-no-gutter">
                                            <div role="gridcell" className="data-label" id={"bank-account-" + index + "-hours"}>
                                                {tLang("identityVault.secureStorage.lostWallterWidget.addBankAccountPopup.label.hours")}
                                            </div>
                                        </div>
                                        <div className="col-xs-11 col-sm-7 col-no-gutter">
                                            <div role="gridcell" className="data-value" aria-labelledby={"bank-account-" + index + "-hours"}>
                                                {bankAccount.hours}
                                            </div>
                                        </div>
                                    </div>
                                    <div role="row" className="data-row condensed row">
                                        <div className="col-xs-12 col-sm-4 col-no-gutter">
                                            <div role="gridcell" className="data-label" id={"bank-account-" + index + "-website"}>
                                                {tLang("identityVault.secureStorage.lostWallterWidget.addBankAccountPopup.label.website")}
                                            </div>
                                        </div>
                                        <div className="col-xs-11 col-sm-7 col-no-gutter">
                                            <div role="gridcell" className="data-value" aria-labelledby={"bank-account-" + index + "-website"}>
                                                {bankAccount.website}
                                            </div>
                                        </div>
                                    </div>
                                    <div role="row" className="data-row condensed row">
                                        <div className="col-xs-12 col-sm-4 col-no-gutter">
                                            <div role="gridcell" className="data-label" id={"bank-account-" + index + "-notes"}>
                                                {tLang("identityVault.secureStorage.lostWallterWidget.addBankAccountPopup.label.notes")}
                                            </div>
                                        </div>
                                        <div className="col-xs-11 col-sm-7 col-no-gutter">
                                            <div role="gridcell" className="data-value" aria-labelledby={"bank-account-" + index + "-notes"}>
                                                {bankAccount.notes}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="row between-xs margin-top-l">
                                    <div className="col-xs flex-grow-null col-no-gutter"></div>
                                    <div className="col-xs flex-grow-null col-no-gutter">
                                        <ul className="list-reset list-inline">
                                            <li>
                                                <button
                                                    type="button"
                                                    className="btn-default btn-red-outline btn-no-border"
                                                    onClick={() => showDeleteWalletDialog(bankAccount)}
                                                >
                                                    <span className="btn-icon">
                                                        <em className="las la-trash-alt"></em>
                                                    </span>
                                                    <span className="btn-text">
                                                        {tLang("identityVault.secureStorage.lostWallterWidget.addBankAccountPopup.deleteButtonText")}
                                                    </span>
                                                </button>
                                            </li>
                                            <li className="margin-left-xs">
                                                <button
                                                    type="button"
                                                    className="btn-default btn-primary-outline"
                                                    id="edit-credit-card-1"
                                                    onClick={() => showBankAccountDialog(bankAccount)}
                                                >
                                                    <span className="btn-icon">
                                                        <em className="las la-edit-alt"></em>
                                                    </span>
                                                    <span className="btn-text">
                                                        {tLang("identityVault.secureStorage.lostWallterWidget.addBankAccountPopup.editDetailsButtonText")}
                                                    </span>
                                                </button>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}

            {/* Delete modal*/}

            {deleteWalletDialogIsVisible && (
                <DialogComponent dialogId="dialog-delete-bank-account-wallet" title="Delete Wallet" closeDialog={closeDeleteWalletDialog}>
                    <ConfirmDeleteWalletDialog
                        requestDataCallback={props.requestDataCallback}
                        closeDialog={closeDeleteWalletDialog}
                        walletItem={selectedItem}
                        itemType="bank-account"
                    />
                </DialogComponent>
            )}

            {/* Edit modal*/}

            {bankAccountDialogIsVisible && (
                <DialogComponent dialogId="dialog-edit-bank-account-wallet" title="Edit Credit Card Wallet" closeDialog={closeBankAccountDialog}>
                    <BankAccountDialog
                        requestDataCallback={props.requestDataCallback}
                        closeDialog={closeBankAccountDialog}
                        walletItem={selectedItem}
                        isNew={false}
                    />
                </DialogComponent>
            )}
        </React.Fragment>
    );
};

export default BankAccount;
